import 'bootstrap';
import bootbox from 'bootbox';
import Toastify from "toastify-js";

App.Helper =
{
  showMessageSuccess: function(content)
  {
    App.Helper.showMessage(content, false);
  },

  showMessageError: function(content)
  {
    App.Helper.showMessage(content, true);
  },

  showMessage: function(content, error)
  {
    let backgroundColor = "linear-gradient(to right, #366092, #244061)"; // blue
    if (error)
    {
      backgroundColor = "linear-gradient(to right, #953734, #632423)"; // red
    }

    Toastify(
    {
      text: content,
      duration: 10000,
      close: true,
      stopOnFocus: true,
      backgroundColor: backgroundColor,
    }).showToast();
  },

  ajaxCall: function(url, functionParams, ajaxParams)
  {
    var defaultAjaxParams = 
    {
      method: "POST",
      sourceEl: false,
      effectTarget: false,
      onSuccess: $.noop,
      onError: false,
      ignoreError: false,
      effect: function()
      {
        if (settings.effectTarget)
        {
          settings.effectTarget.addClass("loading");
        }
      }
    };

    var settings = $.extend({}, defaultAjaxParams, ajaxParams);

    if (settings.sourceEl && settings.sourceEl.length > 0)
    {
      if (settings.sourceEl.prop("disabled"))
      {
        return;
      }
      else
      {
        settings.sourceEl.prop("disabled", true);
      }
    }

    settings.effect();

    let fnClearEffects = function()
    {
      if (settings.sourceEl && settings.sourceEl.length > 0)
      {
        settings.sourceEl.prop("disabled", false);
      }

      if (settings.effectTarget)
      {
        settings.effectTarget.removeClass("loading");
      }
    }

    $.ajax(
    {
      type: "POST",
      url: BASE_URL + url,
      data: functionParams,
      method: settings.method,
      success: function(response)
      {
        fnClearEffects();

        try
        {
          response = $.parseJSON(response);
        }
        catch(e)
        {
          alert(App.Lang.get("error") + ": " + e.message);
          return;
        }

        if (response.type === "success")
        {
          settings.onSuccess(response);
        }
        else if (response.type === "error")
        {
          if (!settings.ignoreError)
          {
            if (!settings.onError)
            {
              alert(App.Lang.get("error") + ": " + response.message);
            }
            else
            {
              settings.onError(response);
            }
          }
        }
      },
      error: function(response)
      {
        fnClearEffects();

        if (!settings.ignoreError)
        {
          /* Catch validation errors */
          if (typeof response.responseJSON !== "undefined" && typeof response.responseJSON.errors !== "undefined")
          {
            let html = '';
            $.each(response.responseJSON.errors, function(name, errors)
            {
              html += '<p class="text-danger">' + App.Lang.get('field_' + name) + '</p><ul>';
              $.each(errors, function(key, error)
              {
                html += '<li>' + error + '</li>';
              });
              html += '</ul>';
            });

            bootbox.dialog(
            {
              message: html
            });
          }
          else
          {
            if (settings.onError)
            {
              settings.onError(response);
            }
            else
            {
              alert(App.Lang.get("error_ajax"));
            }
          }
        }
      }
    });
  },

  bindSidebar: function()
  {
    $("#navSidebarToggle").on("click", function()
    {
      $(this).toggleClass("locked");
      $("#conNavSidebar").toggleClass("locked");
    });
  },

  navigation: function()
  {
    let max = $("#conNavSidebar").height();
    if (max > 5000)
    {
      max = 5000;
    }
    $("#navSidebar").css("maxHeight", max);
  }
};
